import Axios from "../Utils/Interceptors";

class AuthService {
  async login(url, email, password, rememberLogin) {
    const response = await Axios.post(url, {
      Email: email,
      UserName: email,
      Password: password,
      rememberLogin: rememberLogin,
      returnUrl: "",
      sesionCookie: true,
    });

    return response;
  }
}

export default AuthService;
